import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'
import useNoteId from './useNoteId'

const noteQuery = gql`
  query noteById($noteId: ID!) {
    note(id: $noteId) {
      id
      startDate
      endDate
    }
  }
`

/**
 * Hook providing the note based on the noteId found in url parameters
 */
export default function useNote() {
  const noteId = useNoteId()
  const { data: { note } = {} } = useQuery(noteQuery, { skip: !noteId, variables: { noteId } })
  return note
}
